<div class="container-fluid">
  <base-customer-shift-plan-md-organizer
    (editShiftTimes)="openEditShiftTimesModal()"
    (showInquiryInfo)="toggleSidebar.emit()"
    (bubbleClick)="bubbleClick($event)"
  ></base-customer-shift-plan-md-organizer>

  <div class="shift-plan-md-actions d-flex flex-row flex-wrap gap-3 py-4">
    <base-button
      color="dark"
      label="saveRequest"
      [disabled]="!canSubmit"
      (btnClick)="save.emit()"
    ></base-button>
    <base-button
      *ngIf="canPublishInquiry"
      color="primary"
      label="inquiry.publish"
      [disabled]="!canSubmit"
      (btnClick)="publish.emit()"
    ></base-button>
  </div>
</div>

<base-customer-similar-inquiries-md [similarInquiries]="similarInquiries"></base-customer-similar-inquiries-md>

<base-customer-shift-plan-sidebar
  (toggleSidebar)="toggleSidebar.emit()"
  [submitted]="submitted"
  (submittedChange)="submittedChange.emit($event)"
  [inquiryData]="inquiryData"
  [editInquiryForm]="editInquiryForm"
  [isSidebarVisible]="isSidebarVisible"
  [isEmployeeShiftPlan]="isEmployeeShiftPlan"
  [inquiredEmployeeName]="inquiredEmployeeName"
  [inquiryId]="inquiryId"
></base-customer-shift-plan-sidebar>

<ng-template #shiftsUpdateModal>
  <base-customer-shift-details-modal
    [modalRef]="shiftDetailsModalRef"
    [data]="selectedDay"
    [currentShift]="currentShift"
    [timeShifts]="timeShifts"
  ></base-customer-shift-details-modal>
</ng-template>

<ng-template #editTimeShifts>
  <base-customer-edit-shift-view-modal
    [parentForm]="editInquiryForm"
    [modalRef]="timeShiftsModalRef"
  ></base-customer-edit-shift-view-modal>
</ng-template>
